import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropPlantProtection, setFootprintingCropPlantProtectionAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_FARM_CROP_PLANT_PROTECTION } from "consts";

import { FootprintingFarmCropPlantProtectionPayload } from "models";

export const useMutateFootprintingCropPlantProtection = (
  farmId: string,
  cropId: string,
  year: number,
  payload: FootprintingFarmCropPlantProtectionPayload,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? setFootprintingCropPlantProtectionAdmin : setFootprintingCropPlantProtection;
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_CROP_PLANT_PROTECTION, primaryDataId, isAdmin],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_FARM_CROP_PLANT_PROTECTION, primaryDataId, isAdmin],
          ...footprintingCropPrimaryQueryKeys(primaryDataId ?? "", farmId, cropId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
